import React, { memo } from 'react';
import { Card } from 'react-bootstrap';
import MaterialTable from 'material-table';
import TableRowWrapper from './TableRowWrapper';
import icons from 'MaterialTableIcons';
import {
  ActionsColumn,
  EngineColumn,
} from './Components';
import {
  CloudColumn,
  SourceColumn,
} from 'AssetManager/ManagedSources/Components';

const UnknownSourcesTable = ({ unscannedSources }) => {
  const COLUMNS = [
    {
      title: 'NAME',
      field: 'connectionName',
      width: '160px',
      headerStyle: { paddingLeft: '1rem', textAlign: 'left' },
      cellStyle: { paddingLeft: '1rem', textAlign: 'left', fontWeight: 500 },
      defaultSort: 'asc',
      render: ({ connectionName }) => (connectionName ? connectionName : '-')
    },
    {
      title: 'CLOUD',
      field: 'cloud',
      width: '90px',
      headerStyle: { textAlign: 'left' },
      cellStyle: { textAlign: 'left', fontWeight: 500 },
      // Only badge a cloud we actually know (manager-surfaced rows). Existing
      // undiscovered data sources carry no cloud — show a dash rather than guessing.
      render: ({ cloud }) => (cloud ? <CloudColumn cloud={cloud} /> : '-')
    },
    {
      title: 'REGION',
      field: 'region',
      width: '110px',
      cellStyle: { fontWeight: 500 },
      render: ({ region }) => (region ? region : '-')
    },
    {
      title: 'SOURCE',
      field: 'source',
      width: '130px',
      headerStyle: { textAlign: 'left' },
      cellStyle: { textAlign: 'left' },
      render: ({ source }) => (source ? <SourceColumn source={source} /> : '-')
    },
    {
      title: 'ENGINE',
      field: 'engine',
      headerStyle: { textAlign: 'left' },
      cellStyle: { textAlign: 'left' },
      width: '120px',
      render: ({ engine }) => (<EngineColumn engine={engine} />)
    },
    {
      title: 'IP/DNS',
      field: 'ipDns',
      width: '200px',
      sorting: false,
      cellStyle: { fontWeight: 500, wordBreak: 'break-all' },
      render: ({ ipDns }) => (ipDns ? ipDns : '-')
    },
    {
      title: 'DATABASE',
      field: 'database',
      width: '100px',
      sorting: false,
      headerStyle: {
        textAlign: 'center'
      },
      render: ({ database }) => (database ? database : '-')
    },
    {
      title: 'SCHEMA',
      field: 'schema',
      width: '100px',
      sorting: false,
      render: ({ schema }) => (schema ? schema : '-')
    },
    {
      title: 'MANAGE / RUN',
      width: '110px',
      sorting: false,
      headerStyle: { textAlign: 'center' },
      render: (rowData) => (<ActionsColumn data={rowData} />)
    },
  ];

  return (
    <Card className='unknown-sources w-100'>
      <MaterialTable
        data={unscannedSources}
        columns={COLUMNS}
        icons={icons}
        components={{ Row: props => (
          <TableRowWrapper
            {...props}
          />
        )}}
        options={{
          tableLayout: 'fixed',
          pageSize: 10,
          rowStyle: { borderBottom: '1px solid #d3d3d3' },
          search: false,
          showTitle: false,
          filtering: true,
        }}
      />
    </Card>
  );
}

export default memo(UnknownSourcesTable);